import api from './api';

export interface PatientFieldConfig {
  id: number;
  key: string;
  label: string;
  field_type: 'text' | 'bool' | 'date' | 'single_select' | 'number';
  options: { value: string; label: string }[] | null;
  display_in_overview: boolean;
  display_in_edit: boolean;
  display_condition: { field: string; values: string[] } | null;
  default_value: any | null;
  is_required: boolean;
  validation: Record<string, any> | null;
  edit_tab_name: string | null;
  edit_tab_order: number;
  sort_order: number;
  patient_type_id: number;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface PatientFieldConfigCreate {
  key: string;
  label: string;
  field_type: string;
  patient_type_id: number;
  options?: { value: string; label: string }[] | null;
  display_in_overview?: boolean;
  display_in_edit?: boolean;
  display_condition?: { field: string; values: string[] } | null;
  default_value?: any | null;
  is_required?: boolean;
  validation?: Record<string, any> | null;
  edit_tab_name?: string | null;
  edit_tab_order?: number;
  sort_order?: number;
}

export interface PatientFieldConfigUpdate {
  key?: string;
  label?: string;
  field_type?: string;
  patient_type_id?: number;
  options?: { value: string; label: string }[] | null;
  display_in_overview?: boolean;
  display_in_edit?: boolean;
  display_condition?: { field: string; values: string[] } | null;
  default_value?: any | null;
  is_required?: boolean;
  validation?: Record<string, any> | null;
  edit_tab_name?: string | null;
  edit_tab_order?: number;
  sort_order?: number;
}

const patientFieldConfigService = {
  getAll: async (tenantId: number, patientTypeId?: number): Promise<PatientFieldConfig[]> => {
    const params: Record<string, number> = { tenant_id: tenantId };
    if (patientTypeId !== undefined) {
      params.patient_type_id = patientTypeId;
    }
    const response = await api.get('/patient-field-configs/', { params });
    return response.data;
  },
  create: async (tenantId: number, data: PatientFieldConfigCreate): Promise<PatientFieldConfig> => {
    const response = await api.post(`/patient-field-configs/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  update: async (id: number, data: PatientFieldConfigUpdate): Promise<PatientFieldConfig> => {
    const response = await api.put(`/patient-field-configs/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/patient-field-configs/${id}`);
  },
};

export default patientFieldConfigService;
